import { useRef, useEffect } from 'react';

/**
 * A custom hook to get the previous value of a prop or state.
 * @param value The current value.
 * @returns The value from the previous render.
 */
export function usePrevious<T>(value: T): T | undefined {
  const ref = useRef<T>();
  useEffect(() => {
    ref.current = value;
  });
  return ref.current;
}
